<template>
  <div class="fin-page fin-page--customer">
    <div v-if="loading" class="loading-wrap">
      <v-progress-circular indeterminate color="#00AEEF" size="48" />
      <p>Loading…</p>
    </div>
    <div v-else class="success-card">
      <div class="success-icon">
        <v-icon size="48" color="white">mdi-check-circle</v-icon>
      </div>
      <h1>Payment received</h1>
      <p class="sub">Your motor policy is being processed. You will receive updates by SMS and email.</p>
      <div class="details-grid">
        <div class="detail-item">
          <label>Cover</label>
          <p>{{ coverLabel }}</p>
        </div>
        <div class="detail-item">
          <label>Vehicle</label>
          <p>{{ vehicleLine }}</p>
        </div>
        <div class="detail-item">
          <label>Premium paid</label>
          <p class="premium">KES {{ formatMoney(premium) }}</p>
        </div>
        <div class="detail-item">
          <label>Quote reference</label>
          <p class="mono">{{ quoteId }}</p>
        </div>
      </div>
      <div class="actions">
        <button type="button" class="btn-outline" @click="$router.push({ name: motorConfig.routes.dashboard })">
          Dashboard
        </button>
        <button type="button" class="btn-primary" @click="$router.push({ name: 'MyPolicies' })">
          My policies
        </button>
        <button type="button" class="btn-outline" @click="$router.push({ name: motorConfig.routes.start })">
          Buy another cover
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { MOTOR_COVER_OPTIONS } from '@/constants/motorPrivate';
import { getMotorQuote } from '@/services/customerMotorApi';
import { loadMotorPendingQuote } from '@/utils/saleCache';
import { getMotorChannelConfig } from '@/utils/motorChannel';
import { mapGetters } from 'vuex';

export default {
  name: 'MotorFinalizationPage',
  props: {
    quoteId: { type: [String, Number], required: true },
  },
  data() {
    return {
      motorConfig: getMotorChannelConfig(),
      loading: true,
      quote: {},
      coverLabel: '',
      vehicleLine: '',
      premium: 0,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  async mounted() {
    const pending = loadMotorPendingQuote(this.authenticatedUser?.email) || {};
    const res = await getMotorQuote(this.quoteId);
    if (res.success) this.quote = res.data;
    const riskId = pending.riskId || parseInt(this.$route.query.riskId, 10);
    const risk = (this.quote.covertypes || []).find((c) => c.riskId === riskId);
    const coverId = Number(risk?.covertypeId || pending.covertypeId);
    this.coverLabel = MOTOR_COVER_OPTIONS.find((o) => o.covertypeId === coverId)?.label || 'Motor';
    const car = risk?.car || {};
    this.vehicleLine = [car.make, car.model, car.registrationNumber].filter(Boolean).join(' · ');
    this.premium = risk?.riskPremDto?.totalPremium || 0;
    this.loading = false;
  },
  methods: {
    formatMoney(n) {
      return Number(n || 0).toLocaleString('en-KE');
    },
  },
  metaInfo: { title: 'Motor — Complete' },
};
</script>

<style scoped>
.fin-page { max-width: 640px; margin: 0 auto; padding: 32px 24px; }
.loading-wrap { text-align: center; padding: 48px; color: #64748b; }
.success-card {
  background: white; border-radius: 16px; padding: 32px 28px; text-align: center;
  border: 1px solid #e8edf2; box-shadow: 0 4px 24px rgba(24, 70, 121, 0.1);
}
.success-icon {
  width: 72px; height: 72px; border-radius: 50%; background: #16a34a;
  display: flex; align-items: center; justify-content: center; margin: 0 auto 20px;
}
.success-card h1 { font-size: 1.4rem; color: #1e4276; margin: 0 0 8px; }
.sub { color: #64748b; font-size: 0.9rem; margin: 0 0 24px; }
.details-grid {
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px; text-align: left;
  background: #f8fafc; border-radius: 12px; padding: 20px; margin-bottom: 24px;
}
.detail-item label { font-size: 0.68rem; text-transform: uppercase; color: #94a3b8; font-weight: 600; }
.detail-item p { margin: 4px 0 0; font-weight: 600; color: #1e4276; }
.detail-item .premium { color: #00aeef; font-size: 1.1rem; }
.detail-item .mono { font-family: monospace; font-size: 0.8rem; }
.actions { display: flex; gap: 10px; flex-wrap: wrap; justify-content: center; }
.btn-outline, .btn-primary {
  padding: 11px 18px; border-radius: 10px; font-weight: 700; cursor: pointer;
}
.btn-outline { background: white; border: 1px solid #cbd5e1; color: #1e4276; }
.btn-primary { background: #00aeef; color: white; border: none; }
@media (max-width: 500px) {
  .fin-page { padding: 16px 12px 88px; }
  .success-card { padding: 22px 16px; border-radius: 14px; }
  .success-card h1 { font-size: 1.2rem; }
  .sub { font-size: 0.82rem; }
  .details-grid {
    grid-template-columns: 1fr;
    padding: 14px;
    gap: 12px;
  }
  .actions {
    flex-direction: column;
    align-items: stretch;
  }
  .actions .btn-outline,
  .actions .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 46px;
  }
}
</style>
